import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Button, FormControlLabel, Typography, RadioGroup,
} from '@material-ui/core';
import {
  setDownloadTarget,
  setDownloadConfig,
  setDownloadConditionFlg,
  createDownloadFile,
} from '../../actions/CompanyAction';
import {
  setSystemLodingFLg,
} from '../../actions/CommonAction';
import {
  DOWNLOAD_TARGET,
  DOWNLOAD_VALUE,
} from '../../../common/const';
import styles from './CompanyDownloadComponent.module.css';
import CustomRadio from '../common/CustomRadio';
import CustomCheckbox from '../common/CustomCheckbox';

class CompanyDownloadComponent extends Component {
  componentDidMount() {
    const {
      setDownloadConfigAct,
      setDownloadTargetAct,
    } = this.props;
    setDownloadConfigAct(DOWNLOAD_VALUE.ALL);
    setDownloadTargetAct();
  }

  componentDidUpdate(preProps) {
    const {
      downloadConditionFlg,
      setDownloadConfigAct,
      setDownloadTargetAct,
    } = this.props;
    if (preProps.downloadConditionFlg !== downloadConditionFlg
      && !downloadConditionFlg) {
      // Popup表示フラグがfalseに変更された場合、ダウンロード対象、項目を初期化
      setDownloadConfigAct(DOWNLOAD_VALUE.ALL);
      setDownloadTargetAct();
    }
  }

  onClickCreateDownloadFile = async () => {
    const {
      createDownloadFileAct,
      setSystemLodingFLgAct,
    } = this.props;
    setSystemLodingFLgAct(true);
    await createDownloadFileAct();
    setSystemLodingFLgAct(false);
  }

  onChangeDownloadTarget = (downloadTarget) => {
    const { setDownloadTargetAct, downloadCondition } = this.props;
    const DownloadTarget = downloadCondition.download_target;
    let newTarget = [];

    if (DownloadTarget.indexOf(downloadTarget) === -1) {
      // 選択したダウンロード対象をダウンロード対象リストに追加
      newTarget.push(downloadTarget);
      // 他に選択済のダウンロード対象がある場合はダウンロード対象リストに追加
      if (DownloadTarget && DownloadTarget.length > 0) {
        newTarget = DownloadTarget.concat(newTarget);
      }
    } else {
      // チェックOFFに変更したダウンロード対象の配列位置を取得
      const delIndex = DownloadTarget.indexOf(downloadTarget);
      // 配列位置が取得できた場合、該当のダウンロード対象を削除
      if (delIndex >= 0) {
        newTarget = DownloadTarget.concat(newTarget);
        newTarget.splice(delIndex, 1);
      }
    }
    setDownloadTargetAct(newTarget);
  }

  onChangeDownloadValue = (target) => {
    const { setDownloadConfigAct } = this.props;
    setDownloadConfigAct(target);
  }

  render() {
    const {
      downloadCondition,
      downloadConditionFlg,
      downloadLimitOverFlg,
      downloadLimitOverMessage,
      setDownloadConfigAct,
      setDownloadConditionFlgAct,
    } = this.props;

    return (
      downloadConditionFlg && (
        <div className={`${styles.companylistdownload}`}>
          {!downloadLimitOverFlg && (
            <div className={`${styles.contents}`}>
              <div className={`${styles.message}`}>ダウンロードオプションを指定してください。</div>
              <div className={`${styles.condition}`}>
                <Typography className={`${styles.title}`}>ダウンロード対象</Typography>
                <div className={`${styles.row}`}>
                  <div className={`${styles.item}`}>
                    <FormControlLabel
                      control={(
                        <CustomCheckbox
                          checked={downloadCondition.download_target
                            .includes(DOWNLOAD_TARGET.HEAD_OFFICE)}
                          onChange={() => this.onChangeDownloadTarget(DOWNLOAD_TARGET.HEAD_OFFICE)}
                        />
                        )}
                      label="本社のみ"
                    />
                  </div>
                </div>
              </div>
              <div className={`${styles.condition}`}>
                <div className={`${styles.title}`}>ダウンロードする項目</div>
                <RadioGroup row>
                  <div className={`${styles.item}`}>
                    <FormControlLabel
                      control={<CustomRadio />}
                      label="全項目"
                      className={downloadCondition.download_config === DOWNLOAD_VALUE.ALL
                        ? styles.radiobuttoncheck : styles.radiobutton}
                      checked={downloadCondition.download_config === DOWNLOAD_VALUE.ALL}
                      onClick={() => setDownloadConfigAct(DOWNLOAD_VALUE.ALL)}
                    />
                  </div>
                  <div className={`${styles.item}`}>
                    <FormControlLabel
                      control={<CustomRadio />}
                      label="カスタムレイアウト"
                      className={downloadCondition.download_config === DOWNLOAD_VALUE.MINIMUM
                        ? styles.radiobuttoncheck : styles.radiobutton}
                      checked={downloadCondition.download_config === DOWNLOAD_VALUE.MINIMUM}
                      onClick={() => setDownloadConfigAct(DOWNLOAD_VALUE.MINIMUM)}
                    />
                  </div>
                  <div className={`${styles.item}`}>
                    <FormControlLabel
                      control={<CustomRadio />}
                      label="TSR企業情報のみ"
                      className={downloadCondition.download_config === DOWNLOAD_VALUE.TSR_ONLY
                        ? styles.radiobuttoncheck : styles.radiobutton}
                      checked={downloadCondition.download_config === DOWNLOAD_VALUE.TSR_ONLY}
                      onClick={() => setDownloadConfigAct(DOWNLOAD_VALUE.TSR_ONLY)}
                    />
                  </div>
                </RadioGroup>
              </div>
              <div className={`${styles.button}`}>
                <Button
                  variant="contained"
                  className={`${styles.buttoncancel} cancel`}
                  onClick={(() => setDownloadConditionFlgAct(false))}
                >
                  キャンセル
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  className={`${styles.buttonnormal}`}
                  onClick={this.onClickCreateDownloadFile}
                >
                  決定
                </Button>
              </div>
            </div>
          )}
          {downloadLimitOverFlg && (
            <div className={`${styles.limitovercontents}`}>
              <div className={`${styles.conf}`}>
                {downloadLimitOverMessage}
              </div>
              <div className={`${styles.limitoverbutton}`}>
                <Button
                  variant="contained"
                  className={`${styles.downloadLimitOverCancelButton} cancel`}
                  onClick={(() => setDownloadConditionFlgAct(false))}
                >
                  キャンセル
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  className={`${styles.downloadLimitOverOkButton}`}
                  onClick={this.onClickCreateDownloadFile}
                >
                  OK
                </Button>
              </div>
            </div>
          )}
        </div>
      )
    );
  }
}

export default connect(
  (state) => ({
    // ダウンロードオプションPopup表示フラグ
    downloadConditionFlg: state.company.downloadConditionFlg,
    // ダウンロード件数超過フラグ
    downloadLimitOverFlg: state.company.downloadLimitOverFlg,
    // ダウンロード件数超過メッセージ
    downloadLimitOverMessage: state.company.downloadLimitOverMessage,
    // ダウンロードオプション
    downloadCondition: state.company.downloadCondition,
  }),
  (dispatch) => ({
    setDownloadTargetAct: (str) => dispatch(setDownloadTarget(str)),
    setDownloadConfigAct: (str) => dispatch(setDownloadConfig(str)),
    setDownloadConditionFlgAct: (bool) => dispatch(setDownloadConditionFlg(bool)),
    createDownloadFileAct: () => dispatch(createDownloadFile()),
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
  }),
)(CompanyDownloadComponent);
